import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { first } from 'lodash';
import * as classnames from 'classnames';
import { uploadFileToSessionParticipation } from '../../data/fileImport/participationsActions';

class FileUpload extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fileUploading: false
    };
  }

  /**
   * Select file event: validate file
   */
  fileChangedHandler = event => {
    if (!event.target.files[0]) {
      return false;
    }
    const file = event.target.files[0];
    event.target.value = null;
    this.uploadFileToServer(file);
  };

  /**
   * Upload file to server & update state uploading files
   * @param {*} file
   */
  uploadFileToServer = file => {
    const self = this;

    /** To do :
     * 1. send file to server
     * 2. update state upload progress
     */

    const participation = first(this.props.session.participations);

    if (participation) {
      this.setState({
        fileUploading: true
      });

      const successCallback = () => {
        self.setState({
          fileUploading: false
        });
      };

      const errorCallback = e => {
        alert(e);
        self.setState({
          fileUploading: false
        });
      };

      this.props.dispatch(
        uploadFileToSessionParticipation(
          participation.id,
          this.props.equipmentFile.id,
          file,
          successCallback,
          errorCallback
        )
      );
    }
  };

  render() {
    const hasParticipation = first(this.props.session.participations) !== undefined;
    const className = `file-container session__fileUpload--${
      this.props.nodeUpload ? 'has-file' : 'upload'
    }`;

    const iconClassName = classnames({
      'fas fa-check-circle': this.props.nodeUpload && !this.state.fileUploading,
      'fas fa-spinner': this.state.fileUploading,
      'fas fa-upload': !this.props.nodeUpload && !this.state.fileUploading,
      icon: true
    });

    const participation = first(this.props.session.participations);
    if (participation && participation.status !== 'valid') {
      return null;
    }

    const labelClassName = classnames({
      disabled: !hasParticipation
    });
    return (
      <span className={className}>
        <label
          htmlFor={`session_${this.props.session.id}_file_${this.props.equipmentFile.id}`}
          className={labelClassName}
        >
          <i className={iconClassName} />
        </label>
        <input
          id={`session_${this.props.session.id}_file_${this.props.equipmentFile.id}`}
          disabled={!hasParticipation}
          className="input-upload-file"
          type="file"
          onChange={this.fileChangedHandler}
        />
      </span>
    );
  }
}

FileUpload.propTypes = {
  session: PropTypes.object,
  equipmentFile: PropTypes.object,
  nodeUpload: PropTypes.object
};

export default connect(state => ({
  sessions: state.projects.single.fileImport.sessions
}))(FileUpload);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/FileUpload.js